import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import events from '../hooks/events';

const ThemesDropdownItem = ({ code, name, value }) => {
  const updateTheme = events.useChooseTheme();

  return (
    <Dropdown.Item
      active={code === value}
      selected={code === value}
      onClick={() => updateTheme({ code, name })}
    >
      <Icon name={code === value ? 'check' : undefined} />
      {name}
    </Dropdown.Item>
  );
};

export default ThemesDropdownItem;
